//
//
//
//
//
//
//
//
//


export default {
  name: "TopBenefitBar",
  props: {
    label: {
      type: String,
    },
    backgroundColor: {
      type: String,
      default: "var(--_c-secondary_yellow)"
    },
    link: {
      type: String,
    },
  },
}
